import './App.scss';
import Navbar from './components/Navbar/Navbar';
import {Outlet, useLocation} from 'react-router-dom';
import Footer from './components/Footer/Footer';
import {PhoneIcon} from '@heroicons/react/20/solid';
import Notification from './components/Notification/Notification';
import Breadcrumbs from './components/Breadcrumbs/Breadcrumbs';
import {useEffect, useRef, useState} from 'react';

function App() {
  const location = useLocation();
  const app = useRef();
  const [isFabVisible, setIsFabVisible] = useState(true);

  useEffect(() => {
    document.getElementById('toTop').scrollIntoView({behavior: 'instant', block: 'start'});
  }, [location.pathname]);

  // Auto-toggle FAB every 1 minute
  useEffect(() => {
    const interval = setInterval(() => {
      setIsFabVisible(prev => !prev);
    }, 60000); // 5 seconds for testing (change back to 60000 for production)

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (<div className='app' ref={app}>
    <div id='toTop'></div>
    <Navbar/>
    <main>
      {
        location.pathname !== '/' ?
            <Breadcrumbs/> : undefined
      }
      <Outlet/>
    </main>
    <Footer/>
    <a href={'tel:+1-437-460-9068'} className={`book-service-call ${isFabVisible ? 'expanded' : 'collapsed'}`}>
      <div className={'content'}>
        <div className='icon'>
          <PhoneIcon className={'heroicon-32'}/>
        </div>
        <div className={`text ${isFabVisible ? 'visible' : 'hidden'}`}>+1-437-460-9068</div>
      </div>
    </a>
    <Notification/>
  </div>);
}

export default App;
